import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql, compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import Enroll from '../../components/Enroll';
import enrollMember from '../../mutations/enrollMember';
import createBillMe from '../../mutations/createBillMe';
import enrollPerson from '../../mutations/enrollPerson';
import memberSearch from '../../queries/memberSearch';
import standardizeAddress from '../../queries/standardizeAddress';
import getEncryptData from '../../queries/getEncryptedData';
import sendEmailToMember from '../../queries/sendEmailToMember';
import createBillMeExistingPerson from '../../mutations/createBillMeExistingPerson';
import {
  setMemberRequest,
  setSuccessMessage,
  setErrorMessage,
  setPaymentRequest,
  removePaymentResponse,
  removeEnrollPersonRequest,
} from '../../actions';

const searchMember = client => (
  ({ firstName, lastName, zipCode, country, birthMonth, birthDay, birthYear }) => (
    client.query({
      query: memberSearch,
      variables: {
        input: { firstName, lastName, zipCode, country, birthMonth, birthDay, birthYear },
      },
      fetchPolicy: 'network-only',
    })
  )
);

const validateAddress = client => (
  ({ addressLine1, addressLine2, city, state, zipCode, country }) => (
    client.query({
      query: standardizeAddress,
      variables: {
        input: { addressLine1, addressLine2, city, state, zipCode, country },
      },
      fetchPolicy: 'network-only',
    })
  )
);

const encryptData = client => (
  ({ data, saltName }) => (
    client.query({
      query: getEncryptData,
      variables: {
        input: { data, saltName },
      },
      fetchPolicy: 'network-only',
    })
  )
);

const sendEmail = client => (
  ({ fromEmailAddress, toEmailAddress, subject, htmlBody }) => (
    client.query({
      query: sendEmailToMember,
      variables: {
        input: { fromEmailAddress, toEmailAddress, subject, htmlBody },
      },
      fetchPolicy: 'network-only',
    })
  )
);

export const EnrollWrapper = props => (
  <Enroll
    searchMember={searchMember(props.client)}
    validateAddress={validateAddress(props.client)}
    encryptData={encryptData(props.client)}
    sendEmail={sendEmail(props.client)}
    {...props}
  />
);
EnrollWrapper.propTypes = {
  client: PropTypes.object.isRequired,
};

export const mapStateToProps = ({ paymentResponse, paymentRequest, enrollPersonRequest }) => {
  const props = {
    paymentResponse,
  };
  if (!isEmpty(paymentRequest)) {
    props.paymentRequest = paymentRequest;
  }
  if (!isEmpty(enrollPersonRequest)) {
    props.enrollPersonRequest = enrollPersonRequest;
  }
  return props;
};

export default compose(
  graphql(enrollMember, {
    name: 'enrollMember',
    options: { notifyOnNetworkStatusChange: true },
  }),
  graphql(createBillMe, {
    name: 'createBillMe',
    options: { notifyOnNetworkStatusChange: true },
  }),
  graphql(enrollPerson, {
    name: 'enrollPerson',
    options: { notifyOnNetworkStatusChange: true },
  }),
  graphql(createBillMeExistingPerson, {
    name: 'createBillMeExistingPerson',
    options: { notifyOnNetworkStatusChange: true },
  }),
)(withRouter(connect(mapStateToProps, {
  setMemberRequest,
  setSuccessMessage,
  setErrorMessage,
  setPaymentRequest,
  removePaymentResponse,
  removeEnrollPersonRequest,
})(withApollo(EnrollWrapper))));



// WEBPACK FOOTER //
// ./src/app/containers/Enroll/index.js